import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, Avatar, CardContent } from '@material-ui/core';

import '../../assets/stylesheets/DashboardView.css';

class GraphCard extends Component {
  render() {
    const {
      title,
      subheader,
      graphAvatar,
      content,
      contentWrapperStyle
    } = this.props;

    return (
      <Card className="graphCard">
        <CardHeader
          avatar={<Avatar aria-label={title}>{graphAvatar}</Avatar>}
          title={title}
          subheader={subheader}
        />
        <CardContent className={contentWrapperStyle}>{content}</CardContent>
      </Card>
    );
  }
}

GraphCard.propTypes = {
  title: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  graphAvatar: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  contentWrapperStyle: PropTypes.string.isRequired
};

export default GraphCard;
